<div class="content">
  <div class="content--right">
    <div class="buttons">
      <app-icon-button
        *ngIf="userType === type.Jobseeker || userType === type.Internal"
        (click)="onEdit(education.objectId)"
        [iconButtonType]="iconButtonType.editNew"
        class="buttons__edit"
      ></app-icon-button>
      <app-icon-button
        *ngIf="userType === type.Jobseeker || userType === type.Internal"
        (click)="onDelete(education.jobseekerEducationId, education.objectId)"
        [iconButtonType]="iconButtonType.deleteRed"
        class="buttons__delete"
      ></app-icon-button>
    </div>
  </div>
  <div class="educational-level">
    <svg-icon src="/assets/icons/education-level.svg"></svg-icon>
    {{ education.educationLevel.name }}
  </div>

  <div class="institute-and-title">
    <div class="institution">
      <app-icon
        *ngIf="education.isInModeration"
        [tooltipText]="'label.IsInModeration' | translate"
        [iconButtonType]="iconButtonType.moderation"
        class="mod-icon mod-icon--desktop"
      ></app-icon>
      <app-icon
        *ngIf="education.isInModeration"
        [tooltipText]="'label.IsInModeration' | translate"
        [iconButtonType]="iconButtonType.moderation"
        class="mod-icon mod-icon--mobile"
      ></app-icon>
      <span>{{ education.educationalProgramName }}</span>
    </div>

    <div class="dates">
      <span
        >{{
          education.dateFromMonth == null
            ? education.dateFromYear
            : (education.educationDateFrom
              | date: 'y MMMM':null:currentLang)
        }}
        -
      </span>
      <span>{{
        education.dateToMonth == null
          ? education.dateToYear
          : (education.educationDateTo | date: 'y MMMM':null:currentLang)
      }}</span>
    </div>
  </div>

  <div class="education">
    <div *ngIf="education.hasProgram" class="education__program">
      {{ education.institution }}
    </div>
    <div *ngIf="education.hasSpecialization" class="education__specialization">
      {{ education.specialization }}
    </div>
    <div class="education__description">{{ education.description }}</div>
  </div>

  <div
    *ngIf="education.attachment != null"
    class="attachment"
    [ngClass]="{ 'attachment--filled': education.attachment != null }"
  >
    <app-advanced-button
      (click)="downloadAttachment(education.objectId)"
      [iconType]="iconButtonType.attachment"
      [text]="'label.Attachment' | translate"
      [type]="'blue'"
      class="add-button"
    ></app-advanced-button>
  </div>
</div>
